import $ from 'jquery';
import 'what-input';
import LocomotiveScroll from 'locomotive-scroll';
import Swiper, { Navigation, Pagination, Autoplay, Mousewheel } from 'swiper';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Autoplay, Mousewheel]);

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';

$(window).bind("load", function() {
	$("html").addClass("is-ready");
});

window.jQuery(function ($) {
	carouselHome();
	carouselFeature();
	carouselMessage();
	carouselTestimonial();
	carouselTitlePagination();
	categoriesToggle();
	contentCarousel();
	cookieBanner();
	cursor();
	filterToggle();
	locoScroll();
	menuSecondary();
	menuToggle();
	planOptionSelect();
	planOptionsModal();
	plans();
	profileMenuToggle();
	saveToggle();
	shareToggle();
	showHide();
	switchToggle();
	toolbarToggle();
	videoModal();
	toggleSearch();

	function carouselHome() {
		new Swiper('.masthead-home.swiper-container', {
			speed: 800,
			loop: true,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
			},
			pagination: {
				el: '.masthead-home .swiper-pagination',
				clickable: true,
			},
		});
	}


	function carouselFeature() {
		new Swiper('.masthead-feature.swiper-container', {
			speed: 800,
			loop: true,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
			},
			pagination: {
				el: '.masthead-feature .swiper-pagination',
				clickable: true,
			},
		});
	}

	function carouselMessage() {
		new Swiper('.message-carousel.swiper-container', {
			speed: 800,
			loop: true,
			grabCursor: true,
			autoplay: {
				delay: 2500,
				disableOnInteraction: false,
			}
		});
	}

	function carouselTestimonial() {
		new Swiper('.testimonial .swiper-container', {
			loop: true,
			grabCursor: true,
			autoplay: {
				delay: 15000,
				disableOnInteraction: false,
			},
			pagination: {
				el: '.testimonial .swiper-pagination',
				clickable: true,
			},
		});
	}

	function carouselTitlePagination() {
		var names = [];
		var titles = document.querySelectorAll(".carousel-title-pagination .swiper-wrapper .swiper-slide");

		Object.keys(titles).forEach(index => {
			names.push(titles[index].dataset.name);
		});

		new Swiper('.carousel-title-pagination .swiper-container', {
			loop: true,
			speed: 800,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
			},
			pagination: {
				el: '.carousel-title-pagination .swiper-pagination',
				type: 'custom',
				clickable: true,
				renderCustom: function(swiper, current, total) {
					var text = "<div>";

					for (let i = 1; i <= total; i++) {
						if (current == i) {
						text += "<span class='swiper-pagination-bullet active'>" + names[i-1] + "</span>";
						} else {
							text += "<span class='swiper-pagination-bullet'>" + names[i-1] + "</span>";
						}
					}
					text += "</div>";
					return text;
				}
			}
		});
	}


	function contentCarousel() {
		new Swiper('.content-stream .swiper-container', {
			slidesPerView: 'auto',
			spaceBetween: 16,
			watchOverflow: true,
			mousewheel: {
				forceToAxis: true,
			},
			speed: 400,
			breakpoints: {
				640: {
					spaceBetween: 20,
				},
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		});
	}

	function cursor() {
		var $cursor = $('.js-cursor-el');
		var $body = $('body');

		var lastMousePosition = { x: 0, y: 0 };

		function onMouseDown() {
			$cursor.addClass('is-mouse-down');
			requestAnimationFrame(update);
		}

		function onMouseUp() {
			$cursor.removeClass('is-mouse-down');
			requestAnimationFrame(update);
		}

		function onMouseMove(evt) {
			lastMousePosition.x = evt.clientX;
			lastMousePosition.y = evt.clientY;
			requestAnimationFrame(update);
		}

		function update() {
			// Get the element we're hovered on
			var hoveredEl = document.elementFromPoint(lastMousePosition.x, lastMousePosition.y);

			// Check if the element or any of its parents have a .js-cursor class
			if ($(hoveredEl).parents('.js-cursor').length || $(hoveredEl).hasClass('js-cursor')) {
				$body.addClass('is-cursor-active');
				$cursor.addClass('is-active');
			} else {
				$body.removeClass('is-cursor-active');
				$cursor.removeClass('is-active');
			}

			// now draw object at lastMousePosition
			$cursor.css({
				'transform': `translate3d(${lastMousePosition.x}px, ${lastMousePosition.y}px, 0)`
			});
		}

		document.addEventListener('mousedown', onMouseDown, false);
		document.addEventListener('mouseup',   onMouseUp,   false);
		document.addEventListener('mousemove', onMouseMove, false);

		// Clear on scroll
		document.addEventListener('scroll', update, false);
	}

	function filterToggle() {
		$('#js-filter-toggle').click(function (e) {
			e.preventDefault();
			$($(this).attr('href')).toggleClass('is-active');
			$(this).toggleClass('is-active');
		});
	}

	function categoriesToggle() {
		$('#js-categories-toggle').click(function (e) {
			e.preventDefault();
			$($(this).attr('href')).toggleClass('is-active');
			$($(this).attr('href')).parent().toggleClass('is-active');
			$(this).toggleClass('is-active');
			$("body").toggleClass('lock-scroll');
		});
	}

	function locoScroll() {

		var scroll = new LocomotiveScroll({
			el: document.querySelector('body'),
			smooth: false,
			offset: ["20%",0]
		});

		setInterval(() => scroll.update(), 1000);
	}

	function menuSecondary() {
		var text = $('.menu-secondary .is-active').text()
		$('.menu-secondary span').append(text);

		$('.menu-secondary span').click(function () {
			$(this).siblings('ul').fadeToggle(250);
			$(this).toggleClass('is-active');
		});
	}

	function menuToggle() {
		$('#js-menu-toggle').click(function (e) {
			e.preventDefault();
			$($(this).attr('href')).toggleClass('is-active');
			$("body").toggleClass("lock-scroll");
			$(this).toggleClass('is-active');

			if (!$($(this).attr('href')).hasClass('is-active')) {
				$("body").removeClass('lock-scroll');
				$("#js-categories").removeClass('is-active');
				$("#js-categories").parent().removeClass('is-active');
			}

			if($('.banner').hasClass('banner--search-open')) {
				$('.banner').toggleClass('banner--search-open');
				$('.banner__search-dropdown').slideToggle('fast');
			}
		});

		$('.menu span').click(function () {
			$(this).siblings('.menu-children').fadeToggle(250);
			$(this).toggleClass('is-active');
		});
	}

	function planOptionsModal() {
		$('[data-plan-option]').on('click', function (e) {
			console.log($('#' + $(this).data('modal')));
			var targetModal = $('#' + $(this).data('modal'));
			targetModal.trigger('open');
			e.preventDefault();
		});
	}

	function planOptionSelect() {
		$('.plan-select').on('click', function (e) {
			location.href = $('input[name="content"]:checked').val();
			e.preventDefault();
		});
	}

	function plans() {
		$("#plan-tabs a").click(function() {
			var position = $("#plan-step-2").offset().top;
			$("html, body").animate({
				scrollTop: position
			}, 500);
			$('#plans-content').show(250).addClass('is-active');
		});
	}

	function profileMenuToggle() {
		$('#js-account-menu-toggle').click(function (e) {
			e.preventDefault();
			$($(this).attr('href')).toggleClass('is-active');
			$(this).toggleClass('is-active');
		});
	}

	function saveToggle() {
		$('.save').click(function (e) {
			e.preventDefault();
			$(this).toggleClass('is-active');
		});
	}

	function shareToggle() {
		$('#js-share-toggle').click(function (e) {
			e.preventDefault();
			$($(this).attr('href')).toggleClass('is-active');
			$(this).toggleClass('is-active');
		});
	}

	function showHide() {
		$('.show-hide-toggle').click(function () {
			$(this).siblings('.show-hide-content').fadeToggle(250);
			$(this).toggleClass('is-active');
		});
	}

	function switchToggle() {
		$('.switch-toggle').click(function () {
			$('.switch-toggle').toggleClass('toggled');
			$('.annual').toggleClass('hide');
			$('.monthly').toggleClass('hide');
		});
	}


	function toolbarToggle() {
		$('#js-toolbar-toggle').click(function() {
			$('.toolbar__menu').toggleClass('is-active');
			var $this = $(this);
			$this.toggleClass("is-active");
		});
	}

	function videoModal() {
		$('[data-video-id]').on('click', function (e) {
			var targetModal = $('#' + $(this).data('modal'));
			targetModal.find('iframe').attr("src", "https://www.youtube.com/embed/" +  $(this).data("video-id"));
			targetModal.trigger('open');
			e.preventDefault();
		});

		$(document).on('closed.zf.reveal', '#video-modal[data-reveal]', function() {
			$(this).find('iframe').attr("src", "");
		});
	}

	function toggleSearch() {
		$('#js-search-toggle').click(function() {
			$('.banner').toggleClass('banner--search-open');
			$('.banner__search-dropdown').slideToggle('fast');
		})

		$('.banner__search-form button').click(function () {
			$('.banner').toggleClass('banner--search-open');
			$('.banner__search-dropdown').slideToggle('fast');
		})
	}


	function cookieBanner () {
		if (localStorage.getItem('cookieSeen') != 'shown') {
			$('.cookie-banner').delay(2000).addClass('is-active');
		};

		$('.cookie-banner .button').click(function() {
			$('.cookie-banner').fadeOut();
			localStorage.setItem('cookieSeen','shown');
		})
	}

});

$(document).foundation();
